// Imports
import planMapping from '../billing/plan-mapping';
import isValidSubscriptionSize from './is-valid-subscription-size';
import specialSizes from './special-sizes';


/** Shareable to determine the maximum email accounts available for a subscription at a given size */
export default function determineEmailAccountLimit(options: {
	plan: (typeof planMapping)[keyof typeof planMapping];
	size: number;
}) {
	// Handle unsupported plans
	if (options.plan === planMapping.free || options.plan === planMapping.inform) {
		return 0;
	}
	
	
	// Verify size
	if (!isValidSubscriptionSize(options)) {
		throw new Error(`Unexpected website size: ${options.size}`);
	}
	
	
	// Handle special sizes
	if (options.size === specialSizes.BIG_DATA) {
		return 5;
	}
	
	if (options.size === specialSizes.LEGACY) {
		return 25;
	}
	
	if (options.size === specialSizes.TRIAL) {
		return 0;
	}
	
	
	// Initialize ranges
	const maxSize = 35;
	const ranges = [
		[50, 15],
		[125, 20],
		[300, 25],
		[1000, 30],
	];
	
	
	// Determine email account limit
	const emailAccountLimit = ranges.find(([limit]) => options.size <= limit)?.[1] ?? maxSize;
	
	
	// Return
	return emailAccountLimit;
}
